export default [
    {
        path: '/vms',
        component: () => import('../pages/vms/Index.vue'),
        children: [
            {
                path: '',
                name: 'vms/list',
                meta: {
                    layout: 'default',
                    breadcrumb: [{ label: 'VMs' }],
                },
                component: () => import('../pages/vms/VMs.vue'),
            },
            {
                path: ':id',
                name: 'vms/detail',
                meta: {
                    layout: 'default',
                    breadcrumb: [{ label: 'VM', to: { name: 'vm' } }, { label: 'VM Detail' }],
                },
                component: () => import('../pages/vms/VMDetail.vue'),
            },
        ],
    },
];
